import { z } from 'zod';

export const backInStockValidator = z.object({
  email: z.string().email({ message: 'Please enter a valid email address' }),
  variantGid: z.string().min(1, { message: 'Variant ID is required' }),
});

export type BackInStockValidatorProps = z.infer<typeof backInStockValidator>;
